@defer {
<div class="flex flex-col min-h-screen">

	<!-- ══ SHOP ════════════════════════════════════════════════════════ -->
	<div class="relative flex flex-col lg:flex-row min-h-screen overflow-hidden pt-24 lg:pt-0">

		<div class="absolute inset-0 pointer-events-none"
		     style="background: linear-gradient(120deg, rgba(238,201,50,0.08) 0%, transparent 50%);">
		</div>
		<img src="assets/images/cross.avif" alt=""
		     class="hidden lg:block absolute left-0 top-1/2 -translate-y-1/2 opacity-20 pointer-events-none select-none h-96 w-auto object-contain">

		<!-- ─── LEFT : Info + catalogue ─── -->
		<div class="relative z-10 order-2 lg:order-1 flex flex-col px-6 sm:px-8 lg:px-20 pt-8 pb-16 lg:py-20 lg:w-1/2 gap-8 lg:gap-10">

			<!-- Eyebrow + title -->
			<div class="flex flex-row gap-5 items-center">
				<div class="w-1 self-stretch bg-peps-gold shrink-0"></div>
				<div class="flex flex-col gap-1">
					<span class="text-sm lg:text-base uppercase font-dinpro-medium tracking-widest text-peps-gold/60">
						{{ 'page.shop.subtitle' | translate }}
					</span>
					<h1 class="text-5xl sm:text-6xl md:text-7xl lg:text-8xl uppercase font-dinpro leading-none"
					    style="background: linear-gradient(90deg, #EEC932 0%, #fdf7bd 50%, #ffffff 100%); -webkit-background-clip: text; -webkit-text-fill-color: transparent; background-clip: text;">
						{{ 'page.shop.title' | translate }}
					</h1>
				</div>
			</div>

			<!-- Description -->
			<p class="font-notosans text-base lg:text-lg text-peps-dark-200 leading-relaxed max-w-md">
				{{ 'page.shop.description' | translate }}
			</p>

			<!-- Key features -->
			<div class="flex flex-col gap-2">
				<div class="flex items-center gap-3 text-peps-dark-200 text-base lg:text-lg font-notosans">
					<div class="w-1 h-1 rounded-full bg-peps-gold shrink-0"></div>
					{{ 'page.shop.feature.duplicates' | translate }}
				</div>
			</div>

			<!-- Catalogue -->
			<div class="flex flex-col gap-6">

				@if (boosters().length === 0) {
					<p class="font-notosans text-base text-peps-dark-200/50">
						{{ 'page.shop.catalog.empty' | translate }}
					</p>+
				} @else {
					<div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
						@for (booster of boosters(); track booster.id) {
							<div
								class="group relative flex flex-col overflow-hidden bg-peps-dark-600 hover:bg-peps-dark-500 transition-all duration-300 hover:-translate-y-1"
								[class.opacity-60]="isDisabled(booster)"
								[class.cursor-pointer]="isAuthenticated() && !isDisabled(booster)"
								(click)="openModal(booster)"
								(keydown.enter)="openModal(booster)"
								role="button"
								tabindex="0"
							>
								<!-- Liseré haut -->
								<div class="h-0.5 w-full bg-peps-dark-400 group-hover:bg-peps-club transition-colors duration-300"></div>

								<!-- Zone visuelle -->
								<div class="relative flex items-center justify-center py-10 overflow-hidden">
									<div class="absolute inset-0 opacity-30 group-hover:opacity-70 transition-opacity duration-500"
									     style="background: radial-gradient(circle at 50% 40%, rgba(238,201,50,0.35), transparent 65%);">
									</div>
									<img src="assets/images/cross.avif" alt=""
									     class="absolute -right-6 -bottom-8 w-32 opacity-[0.06] group-hover:opacity-10 rotate-12 pointer-events-none select-none transition-opacity duration-500">

									<img [src]="boosterImage(booster)" alt=""
									     class="relative z-10 w-24 h-24 lg:w-28 lg:h-28 object-contain drop-shadow-[0_12px_20px_rgba(0,0,0,0.55)] group-hover:scale-110 group-hover:-rotate-3 transition-transform duration-500">

									<!-- Coins HUD -->
									<span class="absolute top-3 left-3 w-4 h-4 border-t border-l border-peps-gold/0 group-hover:border-peps-gold/70 transition-colors duration-300"></span>
									<span class="absolute top-3 right-3 w-4 h-4 border-t border-r border-peps-gold/0 group-hover:border-peps-gold/70 transition-colors duration-300"></span>
									<span class="absolute bottom-3 left-3 w-4 h-4 border-b border-l border-peps-gold/0 group-hover:border-peps-gold/70 transition-colors duration-300"></span>
									<span class="absolute bottom-3 right-3 w-4 h-4 border-b border-r border-peps-gold/0 group-hover:border-peps-gold/70 transition-colors duration-300"></span>
								</div>

								<!-- Corps -->
								<div class="flex flex-col gap-4 p-5 border-t border-peps-dark-400/50">
									<div class="flex flex-col gap-1 min-w-0">
										<span class="text-[11px] uppercase font-dinpro-medium tracking-widest text-peps-gold/50">
											{{ 'page.shop.subtitle' | translate }}
										</span>
										<span class="text-xl lg:text-2xl uppercase font-dinpro text-peps-dark-200 truncate">
											{{ booster.name }}
										</span>
									</div>

									<div class="flex items-center gap-2 text-peps-gold">
										<img src="assets/images/pepscoins.png" alt="" class="size-5">
										<span class="text-2xl font-dinpro tabular-nums">{{ booster.price }}</span>
									</div>

									<div class="relative z-10 flex justify-center pt-1" (click)="$event.stopPropagation()">
										<peps-button-complex
											[label]="buttonLabel(booster)"
											[disabled]="!isAuthenticated() || isDisabled(booster)"
											(buttonClick)="openModal(booster)"
										/>
									</div>
								</div>
							</div>
						}
					</div>
				}
			</div>

		</div>

		<!-- ─── RIGHT : 3D model ─── -->
		<div class="relative order-1 lg:order-2 flex items-center justify-center pb-6 lg:pb-0 lg:w-1/2 lg:py-0 lg:sticky lg:top-0 lg:h-screen">
			<div class="absolute inset-0 pointer-events-none">
				<div class="absolute inset-0"
				     style="background-image: url('assets/images/shop_bg.png'); background-size: cover; background-position: center; background-repeat: no-repeat; opacity: 0.5; transform: rotate(25deg) scale(2);">
				</div>
			</div>
			<peps-booster-canvas />
		</div>

	</div>

</div>

<peps-booster-opening [hasNextBooster]="hasBoostersToOpen()" (openNext)="openNextBooster()" />

@if (selectedBooster()) {
	<div
		class="fixed inset-0 bg-peps-dark-900/85 z-50 flex items-center justify-center px-4 backdrop-blur-sm"
		(click)="onOverlayClick($event)"
	>
		<div class="relative bg-peps-dark-600 w-full max-w-sm flex flex-col overflow-hidden">

			<div class="h-0.5 w-full bg-peps-club"></div>

			<div class="flex flex-col gap-6 p-8">
				<div class="flex flex-row justify-between items-start">
					<h2 class="text-3xl lg:text-4xl uppercase text-peps-dark-200">
						{{ 'page.shop.modal.title' | translate }}
					</h2>
					<button
						class="text-peps-dark-200/40 hover:text-peps-dark-200 transition-colors cursor-pointer"
						(click)="closeModal()"
						(keydown.enter)="closeModal()"
					>
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="size-4 lg:size-5">
							<path fill-rule="evenodd" d="M5.47 5.47a.75.75 0 0 1 1.06 0L12 10.94l5.47-5.47a.75.75 0 1 1 1.06 1.06L13.06 12l5.47 5.47a.75.75 0 1 1-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 0 1-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 0 1 0-1.06Z" clip-rule="evenodd" />
						</svg>
					</button>
				</div>

				<div class="flex flex-row items-center gap-4 bg-peps-dark-700 px-5 py-4">
					<img src="/assets/images/team_peps_logo.avif" class="w-12 h-12 object-contain">
					<div class="flex flex-col gap-0.5">
						<span class="text-xs lg:text-sm uppercase font-dinpro-medium text-peps-gold/60">
							{{ 'page.shop.subtitle' | translate }}
						</span>
						<span class="text-xl lg:text-2xl uppercase font-dinpro text-peps-dark-200">
							{{ selectedBooster()!.name }}
						</span>
					</div>
					<div class="ml-auto flex items-center gap-2 text-peps-gold">
						<img src="assets/images/pepscoins.png" alt="" class="w-6 h-6">
						<span class="font-dinpro text-xl lg:text-2xl">{{ selectedBooster()!.price }}</span>
					</div>
				</div>

				<!-- Quantité -->
				<div class="flex flex-row justify-between items-center">
					<span class="text-base lg:text-lg font-notosans text-peps-dark-200/50">{{ 'page.shop.modal.quantity' | translate }}</span>
					<div class="flex flex-row items-center gap-3">
						<button
							class="size-8 flex items-center justify-center border border-peps-dark-400 text-peps-dark-200/70 hover:text-peps-dark-200 hover:border-peps-dark-300 disabled:opacity-30 disabled:pointer-events-none cursor-pointer transition-colors"
							[disabled]="quantity() <= 1"
							(click)="decrementQuantity()"
							(keydown.enter)="decrementQuantity()"
						>−</button>
						<input
							type="number"
							min="1"
							[max]="maxAffordable()"
							[value]="quantity()"
							(input)="onQuantityInput($event)"
							class="w-14 py-1.5 text-center bg-peps-dark-700 border border-peps-dark-400 text-peps-dark-200 font-dinpro-bold text-lg tabular-nums outline-none focus:border-peps-gold/40 transition-colors"
						/>
						<button
							class="size-8 flex items-center justify-center border border-peps-dark-400 text-peps-dark-200/70 hover:text-peps-dark-200 hover:border-peps-dark-300 disabled:opacity-30 disabled:pointer-events-none cursor-pointer transition-colors"
							[disabled]="quantity() >= maxAffordable()"
							(click)="incrementQuantity()"
							(keydown.enter)="incrementQuantity()"
						>+</button>
					</div>
				</div>

				<!-- Total -->
				<div class="flex flex-row justify-between items-center text-base lg:text-lg font-notosans text-peps-dark-200/50">
					<span>{{ 'page.shop.modal.total' | translate }}</span>
					<span class="flex items-center gap-2 text-peps-gold font-dinpro-bold text-lg lg:text-xl">
						<img src="assets/images/pepscoins.png" alt="" class="w-5 h-5">
						{{ totalPrice() }} PepsCoins
					</span>
				</div>

				@if (user() !== null) {
					<div class="flex flex-row justify-between items-center text-base lg:text-lg font-notosans text-peps-dark-200/50">
						<span>{{ 'page.shop.modal.balance-after' | translate }}</span>
						<span class="font-dinpro-bold text-lg lg:text-xl" [class.text-peps-red]="user()!.coins - totalPrice() < 0">
							{{ user()!.coins - totalPrice() }} PepsCoins
						</span>
					</div>
				}

				<div class="flex flex-row gap-3">
					<button
						class="flex-1 py-3 border border-peps-dark-400 text-peps-dark-200/60 hover:text-peps-dark-200 hover:border-peps-dark-300 uppercase font-dinpro-medium text-sm lg:text-base cursor-pointer transition-colors duration-300"
						(click)="closeModal()"
						(keydown.enter)="closeModal()"
					>
						{{ 'page.shop.modal.cancel' | translate }}
					</button>
					<button
						class="flex-1 py-3 lg:py-4 bg-peps-gold hover:bg-peps-yellow text-peps-dark-700 uppercase font-dinpro-bold text-base lg:text-lg cursor-pointer transition-colors duration-300 disabled:opacity-50 disabled:pointer-events-none"
						[disabled]="isPurchasing() || !canAfford()"
						(click)="confirmPurchase()"
						(keydown.enter)="confirmPurchase()"
					>
						@if (isPurchasing()) {
							<span class="inline-block w-4 h-4 border-2 border-peps-dark-700 border-t-transparent rounded-full animate-spin"></span>
						} @else {
							{{ 'page.shop.modal.confirm' | translate }}
						}
					</button>
				</div>
			</div>
		</div>
	</div>
}
}
